import axios from "axios";
import React, { useEffect, useState } from "react";
import { BASE_URL } from "../../../Utlils";
import { useGlobalContext } from "../../../Contexts/GlobalContext";
import { Toggle } from "../../../components/UiComponents/Ui";

const GlobalProjectSetting = () => {
  const { user, setSnackbar, organization, getOrganization } =
    useGlobalContext();
  const [inputData, setInputData] = useState({});
  const [ridSaving, setRidSaving] = useState(false);

  const handleShowRidToggle = async (e) => {
    const showRid = e.target.checked;
    setRidSaving(true);
    try {
      let updatedOrganization = await axios.put(
        `${BASE_URL}/company/${organization?.id}`,
        { show_rid: showRid }
      );
      setSnackbar(() => ({
        open: true,
        msg: showRid
          ? "RID will be shown in Respondent Answers"
          : "RID will be hidden in Respondent Answers",
        severity: "success",
      }));
      getOrganization(updatedOrganization?.data?.id);
    } catch (error) {
      setSnackbar(() => ({
        open: true,
        msg: error?.response?.data?.message || "Something went wrong !",
        severity: "error",
      }));
    } finally {
      setRidSaving(false);
    }
  };
  const handleChange = (e) => {
    let { name, value } = e.target;
    setInputData((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let updatedOrganization = await axios.put(
        `${BASE_URL}/company/${organization?.id}`,
        { projectSettings: inputData }
      );
      // console.log("updatedOrganization=>", updatedOrganization);
      setSnackbar((prev) => ({
        open: true,
        msg: "Project setting updated !",
        severity: "success",
      }));
      getOrganization(updatedOrganization?.data?.id);
    } catch (error) {
      setSnackbar((prev) => ({
        open: true,
        msg: "Something went wrong !",
        severity: "error",
      }));
    }
  };
  // console.log("inputData=>", inputData);
  // console.log(user);
  // console.log("organization=>",organization);
  useEffect(() => {
    setInputData(organization?.projectSettings);
  }, [Object.keys(organization)?.length]);
  return (
    <form
      className="w-full flex flex-col gap-6 h-full py-5"
      onSubmit={handleSubmit}
    >
      <div className="pb-6 flex items-center justify-between border-b border-gray-200">
        <div className="flex flex-col gap-2 justify-center">
          <h1 className="text-[#0226BE] text-[28px] font-[600]">
            Global Project Settings
          </h1>
          <p className="text-gray-600 text-[14px]">Set global project settings that apply to all surveys</p>
        </div>
        <button
          type="submit"
          disabled={!user?.role === "admin"}
          className="bg-[#0226BE] text-white py-2.5 px-6 rounded-md text-[14px] font-[500] hover:bg-[#021ea8] transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          Update Settings
        </button>
      </div>
      <div className="pb-6 grid grid-cols-2 gap-6 items-start bg-white border border-gray-200 rounded-lg p-6">
        <div className="flex flex-col gap-2">
          <label className="text-[#1a1a1a] text-[14px] font-[500]">
            Expected Drop Off Rate (%)
          </label>
          <input
            type="number"
            pattern="[0-9]*"
            inputMode="numeric"
            placeholder="e.g., 10"
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === "e" || e.key === "+" || e.key === "-") {
                e.preventDefault();
              }
            }}
            disabled={!user?.role === "admin"}
            value={inputData?.expectedDropOfRate}
            name="expectedDropOfRate"
            required
            className="border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 hover:border-gray-400 placeholder:text-gray-400 disabled:bg-gray-50 disabled:cursor-not-allowed"
          />
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-[#1a1a1a] text-[14px] font-[500]">
            Expected Quota Rate (%)
          </label>
          <input
            type="number"
            pattern="[0-9]*"
            inputMode="numeric"
            placeholder="e.g., 2"
            disabled={!user?.role === "admin"}
            onKeyDown={(e) => {
              if (e.key === "e" || e.key === "+" || e.key === "-") {
                e.preventDefault();
              }
            }}
            value={inputData?.expectedQuotaRate}
            onChange={handleChange}
            name="expectedQuotaRate"
            required
            className="border border-gray-300 h-[48px] text-[#1a1a1a] pl-4 pr-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all duration-200 hover:border-gray-400 placeholder:text-gray-400 disabled:bg-gray-50 disabled:cursor-not-allowed"
          />
        </div>
      </div>
      {organization?.ridSettingEnabled ? (
        <div className="flex items-center justify-between gap-6 bg-white border border-gray-200 rounded-lg p-6">
          <div className="flex flex-col gap-1">
            <h2 className="text-[#1a1a1a] text-[16px] font-[600]">
              Show RID in Respondent Answers
            </h2>
            <p className="text-gray-600 text-[14px]">
              Display each respondent's RID as a column in the Resp. Answers
              table and its Excel export.
            </p>
          </div>
          <Toggle
            id="show-rid-toggle"
            checked={organization?.show_rid}
            disabled={ridSaving || user?.role !== "admin"}
            onChange={handleShowRidToggle}
          />
        </div>
      ) : (
        <></>
      )}
      {/* <div className="pb-8 border-b border-[#E0E0E0] grid grid-cols-3 justify-between gap-[40px] items-center">
        <div className="flex flex-col gap-[20px]">
          <h1 className="flex items-center gap-[20px] text-[16px] font-[600]">
            Time Zone
          </h1>
          <select
            name="timeZone"
            id="timeZone"
            className="border py-2 px-4 rounded-[8px] text-[#666] text-[12px]"
            disabled={!user?.role === "admin"}
            onChange={handleChange}
            required
            style={
              user?.role === "admin"
                ? { cursor: "auto" }
                : { cursor: "not-allowed" }
            }
            value={inputData?.timeZone}
          >
            <option value="">Select Time Zone</option>
            {Intl.supportedValuesOf("timeZone")?.map((d, i) => (
              <option value={d} key={i}>
                {d}
              </option>
            ))}
          </select>
        </div>
      </div> */}
    </form>
  );
};

export default GlobalProjectSetting;
